import { Flex } from 'antd'
import { FC } from 'react'
import { styled } from 'styled-components'
import { isPrintJobCancelled } from '../../../../machines-schedule/components/one-machine-schedule/helpers/print-job-helpers'
import {
    buildPrintPlanDateGroups,
    filterPrintQueueEntriesByBrands,
    PRINT_PLAN_MACHINE_CARDS,
} from '../../helpers/build-print-plan-date-groups'
import usePrintPlanSummaryEntries from '../../hooks/use-print-plan-summary-entries'
import SummaryOfMachine from './summary-of-machine'

const FlexStyled = styled(Flex)`
    width: 200px;
    flex-direction: column;
`

interface SummaryProps {
    selectedMachineBrandName: string
    onChangeMachineBrandName: (name: string) => void
}

/**
 * Карточки сводки данных по станкам
 *
 * @category Component
 * @returns
 */
const Summary: FC<SummaryProps> = ({ selectedMachineBrandName, onChangeMachineBrandName }) => {
    const { entries } = usePrintPlanSummaryEntries()

    return (
        <FlexStyled gap={2}>
            {PRINT_PLAN_MACHINE_CARDS.map(item => {
                const brandEntries = filterPrintQueueEntriesByBrands(entries, item.brandNames)
                const dateGroups = buildPrintPlanDateGroups(brandEntries)
                const cancelledCount = brandEntries.filter(entry =>
                    isPrintJobCancelled(entry.print_job)
                ).length

                return (
                    <SummaryOfMachine
                        machineBrandName={item.title}
                        isActive={item.key === selectedMachineBrandName}
                        onClick={() => {
                            onChangeMachineBrandName(item.key)
                        }}
                        dateGroups={dateGroups}
                        showStats={item.showStats}
                        cancelledCount={cancelledCount}
                        key={item.key}
                    />
                )
            })}
        </FlexStyled>
    )
}

export default Summary
